<div class="new-select-label assign-label">
  {{ 'Projects.assignedPerson' | translate }}
  <div
    *ngIf="assignMeOption && !taskSidenavService.isChange"
    class="assign-button"
    (click)="toggleAssignMe()"
  >
    {{ isCurrentUserAssigned ? ('Projects.unassignMe' | translate) : ('Projects.assignMe' | translate) }}
  </div>
</div>

<form [formGroup]="form">
  <ng-select
    class="new-select w-100"
    #select
    ngSelectExtension
    [changePromise]="changePromise.bind(this)"
    [initialValue]="initialValue"
    [searchGetParam]="'search'"
    [url]="URL"
    [clearAllText]="'clearAll' | translate"
    [multiple]="true"
    [loading]="loading"
    [loadingText]="'loading' | translate"
    [placeholder]="'Projects.assignTaskToPerson' | translate"
    [notFoundText]="'Projects.notFoundText' | translate"
    [formControlName]="controlName"
    [ignoreLocalSearch]="true"
    [bindValue]="'id'"
    [bindLabel]="'name'"
    [tabIndex]="tabIndex()"
    [addItems]="addNewPerson"
    [readonly]="readonly"
    [addTagText]="'Projects.add' | translate"
    [addNewItemFunction]="createNewPerson.bind(this)"
    [responseTransform]="transformEmployees.bind(this)"
    [addTag]="addFn() || validateEmail.bind(this)"
  />

  <span
    *ngIf="form.controls[controlName].touched && form.controls[controlName].invalid"
    class="d-flex form-control-error-msg mt-1"
    [innerHTML]="'FormErrors.required' | translate"
  ></span>
</form>
